import GmailIcon from "assets/images/SupportAndChat/GmailIcon.png";
import Button from "components/common/Button";

const ForEmail: React.FC<{ toggle: () => void }> = ({ toggle }) => {
    return (<>
        <div className="py-10 flex flex-col h-full items-center justify-center">
            <img
                className="mb-7"
                src={GmailIcon}
                alt="Icon" />

            <p className="font-[400] text-[16px] text-dark0b mb-3">Hi, send us a Mail today.</p>

            <div className="lg:w-[50%] flex flex-col items-center justify-center">
                <p className="mb-10 text-center font-[400] text-[14px] text-textGrey/70">
                    Reach out to us today with any complaints or suggestions on how we can improve. Send an email to <span className="text-danger">Quivatransfers@gmail.com</span> or use the button below to contact us directly.
                </p>
                <Button buttonType="primary" size="md">Send Us A Mail</Button>
            </div>
        </div>
    </>);
}

export default ForEmail;